// extracted by mini-css-extract-plugin
export var borderRadius = "_gb-4";
export var large = "_gb-3";
export var logoContainer = "_gb-0";
export var nameLogo = "_gb-2";
export var small = "_gb-1";